import { Clue } from "./clue";
import { Row, RowState } from "./Row";
import { maxGuesses } from "./util";
import { minLength, maxLength } from "./Game";


export function About() {
  return (
      <div className="App-about">
          <p><strong>Prattle</strong> is based on the popular <a href="https://www.powerlanguage.co.uk/wordle/" target="_blank">Wordle</a>, but with a Shakespearean twist! All words in this game are ones that Shakespeare used in his plays, poems, and sonnets, as they appear in <a href="https://shakespeare.folger.edu" target="_blank">The Folger Shakespeare</a> online.</p>
          <p>You can choose to play with words as short as { minLength }, or as long as { maxLength }.</p> 
          <hr />
          <span><strong>How to</strong></span>
      <Row
        rowState={RowState.LockedIn}
        wordLength={4}
        cluedLetters={[
          { clue: Clue.Absent, letter: "p" },
          { clue: Clue.Elsewhere, letter: "l" },
          { clue: Clue.Absent, letter: "a" },
          { clue: Clue.Absent, letter: "y" },
        ]}
          />
          <br/>
          <span>You have six tries to guess the correct</span>
          <Row
              rowState={RowState.LockedIn}
              wordLength={4}
              cluedLetters={[
                  { clue: Clue.Absent, letter: "w" },
                  { clue: Clue.Correct, letter: "o" },
                  { clue: Clue.Absent, letter: "r" },
                  { clue: Clue.Absent, letter: "d" },
              ]}
          />
          <br />
          <span>Incorrect guesses appear in</span>
          <Row
              rowState={RowState.LockedIn}
              wordLength={4}
              cluedLetters={[
                  { clue: Clue.Absent, letter: "g" },
                  { clue: Clue.Absent, letter: "r" },
                  { clue: Clue.Absent, letter: "a" },
                  { clue: Clue.Absent, letter: "y" },
              ]}
          />
          <br />
          <span>A correct letter, but in the wrong spot, will appear</span>
          <Row
              rowState={RowState.LockedIn}
              wordLength={4}
              cluedLetters={[
                  { clue: Clue.Absent, letter: "p" },
                  { clue: Clue.Absent, letter: "a" },
                  { clue: Clue.Elsewhere, letter: "l" },
                  { clue: Clue.Absent, letter: "e" },
              ]}
          />
          <br />
          <span>A correct letter, in the correct spot, will appear</span>
          <Row
              rowState={RowState.LockedIn}
              wordLength={4}
              cluedLetters={[
                  { clue: Clue.Absent, letter: "b" },
                  { clue: Clue.Correct, letter: "o" },
                  { clue: Clue.Elsewhere, letter: "l" },
                  { clue: Clue.Absent, letter: "d" },
              ]}
          />
          <br />
          <span>You get six guesses. So feel free to</span>
          <Row
              rowState={RowState.LockedIn}
              wordLength={4}
              cluedLetters={[
                  { clue: Clue.Correct, letter: "f" },
                  { clue: Clue.Correct, letter: "o" },
                  { clue: Clue.Correct, letter: "o" },
                  { clue: Clue.Correct, letter: "l" },
              ]}
          />
          <span>around until you get it right!</span>
      <p>
              "I will be a <strong>fool</strong> in question, hoping to be the wiser by your
              answer."
              <br/>
              <a href="https://shakespeare.folger.edu/shakespeares-works/alls-well-that-ends-well/act-2-scene-2/#line-2.2.38" target="_blank"><i>All's Well That End's Well</i>, 2.2.38–40.</a>
          </p>
          <hr />
          <h2>Nearly any word from Shakespeare could be the answer!</h2>
          <p>The right answer could be one we still use in English every day, like <a href="https://shakespeare.folger.edu/search/?search_text=%22that%22" target="_blank">that</a> or <a href="https://shakespeare.folger.edu/search/?search_text=%22which%22" target="_blank">which</a> or <a href="https://shakespeare.folger.edu/search/?search_text=%22should%22" target="_blank">should</a>, or it could be distinctly Shakespearean, like <a href="https://shakespeare.folger.edu/search/?search_text=%22thou%22" target="_blank">thou</a> or <a href="https://shakespeare.folger.edu/search/?search_text=%22thine%22" target="_blank">thine</a> or <a href="https://shakespeare.folger.edu/search/?search_text=%22Honorificabilitudinitatibus%22" target="_blank">Honorificabilitudinitatibus</a> (just kidding - that one's a little long).</p>
          <p>The answer could even be a character name, like <a href="https://shakespeare.folger.edu/search/?search_text=%22romeo%22" target="_blank">Romeo</a>, a figure from myth or history, like <a href="https://shakespeare.folger.edu/search/?search_text=%22hercules%22" target="_blank">Hercules</a>, or a place name, like <a href="https://shakespeare.folger.edu/search/?search_text=%22arden%22" target="_blank">Arden</a>.</p>
          <h2>What words do we leave out?</h2>
          <p>We have left out words with punctuation or special characters, words from speeches written in other languages, words spelled an unusual way to mimic a noise or a particular accent, and complete nonsense words. This game's hard enough as it is!</p> 
          <p>A few of Shakespeare's words can be upsetting, especially out of context. We want this game to be fun for everyone, so we've left these words out. Don't worry: if you guess one, we'll tell you so that you can try a new word. We'll also give you a link to see how Shakespeare originally used the word you guessed.</p>
          <h2>Acknowledgements</h2>
          <p>A special thanks to <a href="https://github.com/lynn" target="_blank">Lynn</a> on Github, whose open-source code package, <a href="https://github.com/lynn/hello-wordl" target="_blank">Hello Wordl</a>, made this game possible.</p>
    </div>
  );
}
